import { createAction, props } from '@ngrx/store';
import { ITaricCodesState } from './taricCodes.state';

export enum TaricCodesActions {
  TaricCodesRequested = '[TaricCodes] Taric Codes Requested',
  TaricCodesLoaded = '[TaricCodes] Taric Codes Loaded',
  TaricCodesError = '[TaricCodes] Taric Codes Error',
  TaricCodesCollapseTree = '[TaricCodes] Collapse Taric Tree',
  TaricCodesToogleNode = '[TaricCodes] Toogle Taric Node'
}

export const TaricCodesRequested = createAction(TaricCodesActions.TaricCodesRequested);

export const TaricCodesLoaded = createAction(TaricCodesActions.TaricCodesLoaded,
  props<ITaricCodesState>());

export const TaricCodesError = createAction(TaricCodesActions.TaricCodesError);

export const TaricCodesCollapseTree = createAction(TaricCodesActions.TaricCodesCollapseTree);

export const TaricCodesToogleNode = createAction(TaricCodesActions.TaricCodesToogleNode, props<{nodeId:number}>());
